<template>
  <div
    v-if="visible"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    @click.self="closeModal"
  >
    <div
      class="bg-white dark:bg-dark-box-bg rounded-lg shadow-lg p-6 w-full max-w-lg mx-4 text-light-text dark:text-dark-text"
    >
      <!-- Nagłówek -->
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-bold">{{ title }}</h2>
        <button
          @click="closeModal"
          class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          aria-label="Zamknij modal"
        >
          ✕
        </button>
      </div>

      <!-- Treść -->
      <div class="space-y-4">
        <p><b>Imię i Nazwisko Kierowcy:</b> {{ selectedPayoff?.driver?.firstName || 'Nie podano' }} {{ selectedPayoff?.driver?.lastName || 'Nie podano' }}</p>
        <p><b>Rozliczone:</b> {{ selectedOrder?.payoff ? 'Tak' : 'Nie' }}</p>
        <p><b>Koszty Bramek:</b> {{ selectedOrder?.driverGates || '0' }} PLN</p>
        <p><b>Dodatki:</b> {{ selectedOrder?.additvies || '0' }} PLN</p>
        <p><b>Kilometry (Kierowca):</b> {{ selectedOrder?.Kilometers || '0' }} km</p>
        <p><b>Kilometry Zatwierdzone:</b> {{ selectedOrder?.dispatcherKilometers || '0' }} km</p>
        <p><b>Kwota całkowita:</b> {{ selectedOrder?.totalAmount || '0' }} PLN</p>
      </div>

      <!-- Przyciski akcji -->
      <div class="mt-6 flex flex-col sm:flex-row justify-end gap-4">
        <button
          v-if="selectedOrder"
          :disabled="selectedOrder?.payoff"
          @click="goToDriverGates"
          class="px-4 py-2 bg-teal-700 text-white rounded-md hover:bg-teal-800 dark:bg-teal-600 dark:hover:bg-teal-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Edytuj Koszty Bramek
        </button>
        <button
          @click="closeModal"
          class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-500 transition-colors"
        >
          Zamknij
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayoffSummaryModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Podsumowanie Rozliczenia',
    },
    selectedPayoff: {
      type: Object,
      default: () => ({}),
    },
    selectedOrder: {
      type: Object,
      default: null,
    },
    userRole: {
      type: String,
      default: '',
    },
    totalAppKilometers: {
      type: Number,
      default: 0,
    },
    totalDriverKilometers: {
      type: Number,
      default: 0,
    },
    totalDispatcherKilometers: {
      type: Number,
      default: 0,
    },
    totalCostApp: {
      type: String,
      default: '0',
    },
    totalCostDriver: {
      type: String,
      default: '0',
    },
    totalCostDispatcher: {
      type: String,
      default: '0',
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    goToDriverGates() {
      this.$emit('goToDriverGates', this.selectedOrder);
    },
  },
};
</script>